import { motion } from "framer-motion";
import StakeSoonButton from "./StakeSoon";

const STAKE_ART = "/game/gg-arcade.jpg";

export const About = () => {
  return (
    <section
      id="about"
      className="section"
      style={{
        backgroundImage: "linear-gradient(180deg, rgba(5,5,10,0.85), rgba(5,5,10,0.93)), url('/game/gg-grid.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      data-testid="about-section"
    >
      <div className="mx-auto max-w-6xl grid md:grid-cols-5 gap-10 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="md:col-span-2"
        >
          <div className="relative">
            <div
              className="absolute -inset-3 rounded-3xl pointer-events-none"
              style={{ background: "radial-gradient(circle, rgba(255,215,0,0.18), transparent 70%)", filter: "blur(14px)" }}
              aria-hidden="true"
            />
            <img
              src={STAKE_ART}
              alt="Stake to Earn — neon arcade vault"
              className="relative w-full h-72 md:h-96 object-cover rounded-2xl gg-panel gg-glow-gold"
              data-testid="about-image"
            />
            <span
              className="absolute top-4 right-4 gg-panel gg-glow-pink rounded-full px-4 py-1.5 font-display font-bold text-sm uppercase tracking-widest text-[var(--jd-accent)] animate-pulse"
              data-testid="about-soon-badge"
            >
              SOON
            </span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="md:col-span-3"
        >
          <p className="font-accent text-2xl text-[var(--jd-accent)]" data-testid="about-eyebrow">
            lock. chill. earn.
          </p>
          <h2
            className="font-display font-bold text-4xl md:text-5xl uppercase mt-3 leading-[1.02] neon-title-pink"
            data-testid="about-title"
          >
            Stake to Earn.
            <br />
            Coming Soon.
          </h2>
          <p className="mt-5 text-base md:text-lg leading-relaxed text-[var(--jd-ocean)]" data-testid="about-paragraph-1">
            The next chapter of JetDog: lock your $JETDOG in the staking pool and
            watch your bag grow while the good boy rides the waves for you.
            No racing skills required — just diamond paws.
          </p>
          <p className="mt-4 text-base md:text-lg leading-relaxed text-[var(--jd-ocean)]" data-testid="about-paragraph-2">
            Rewards straight from the ocean treasury, paid out
            <b className="text-[var(--jd-text)]"> automatically on-chain</b>. Flexible lock
            periods, boosted APY for long-term hodlers. The vault is being fueled up.
          </p>

          <div className="mt-7 grid grid-cols-3 gap-4">
            <Stat label="Rewards" value="$JETDOG" glow="gg-glow-cyan" testid="about-stat-network" />
            <Stat label="Payouts" value="On-chain" glow="gg-glow-gold" testid="about-stat-tax" />
            <Stat label="Status" value="SOON" glow="gg-glow-pink" testid="about-stat-lp" />
          </div>

          <div className="mt-7">
            <StakeSoonButton className="nb-btn nb-btn--accent" testid="about-stake-button" iconSize={20} />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

const Stat = ({ label, value, glow, testid }) => (
  <div
    className={`gg-panel ${glow} rounded-xl p-4 text-center card-lift`}
    data-testid={testid}
  >
    <p className="text-[10px] uppercase tracking-widest font-mono text-[var(--jd-ocean)]">{label}</p>
    <p className="font-display font-bold text-xl md:text-2xl mt-1">{value}</p>
  </div>
);

export default About;
